import portalApi from './portalApi';

const portalEventService = {
  getEvents: (upcomingOnly = true) => portalApi.get('/portal/events', { params: { upcoming_only: upcomingOnly } }),
};

export default portalEventService;
